// removed by extract-text-webpack-plugin
module.exports = {"mediaWrapper":"_2Bg8zfdfoobmxVOus7IOA","thumbnail":"_3SktRiMwSxfiiWVSWBMArT"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/common/MediaPlayer/MediaPlayer.css
// module id = 1444
// module chunks = 0